import {
  Component,
  inject,
  OnInit,
  ChangeDetectorRef,
  HostListener,
  ElementRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { MdlCall } from '../../components/mdl-call/mdl-call';
import { MdlTask } from '../../components/mdl-task/mdl-task';
import { MdlEvent } from '../../components/mdl-event/mdl-event';
import { CommonModule } from '@angular/common';
import { Mdlfilterectivities } from '../../components/mdl-filter-activities/mdl-filter-activities';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute } from '@angular/router';
import { MdlDelete } from '../../components/mdl-delete/mdl-delete';
import { NavContact } from '../../components/contact/nav-contact/nav-contact';
import { MdlChangeContact } from '../../components/mdl-change-contact/mdl-change-contact';
import { AlertService } from '../../services/alert.service';
import { MdlNewTaskComponent } from '../../components/mdl-new-task/mdl-new-task';
import { FormsModule } from '@angular/forms';
import { MdlSendMail } from '../../components/mdl-send-mail/mdl-send-mail';
import { MdlNewEventComponent } from '../../components/mdl-new-event/mdl-new-event';

@Component({
  selector: 'app-contact-detail',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
    NavContact,
    FormsModule
  ],
  templateUrl: './contact-detail.html',
  styleUrl: './contact-detail.css',
})
export class ContactDetail implements OnInit {
  public contacto: any = null;
  public api = inject(Api);
  public isLoading: boolean = true;
  public errorMessage: string = '';
  public contacto_id: string = '';

  readonly dialog = inject(MatDialog);

  openedMenuId: string | null = null;
  showRecentDropdown: boolean = false;

  public showInfoSection: boolean = true;
  public showDetailsSection: boolean = true;
  public showHistorySection: boolean = true;
  public editInfo: boolean = false;
  public editDetails: boolean = false;
  public editableContact: any = {};


  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.contacto_id = params['id'];
      if (this.contacto_id) {
        this.loadContact(this.contacto_id);
      } else {
        this.errorMessage = 'No se proporcionó un ID de contacto válido';
        this.isLoading = false;
      }
    });
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null): void {
    if (!(target instanceof HTMLElement)) return;

    const clickedInsideRecent = this.elementRef.nativeElement
      .querySelector('.dropdown-trigger')
      ?.contains(target);
    const clickedInsideActions = this.elementRef.nativeElement
      .querySelector('.dots-button')
      ?.contains(target);

    if (!clickedInsideRecent) {
      this.showRecentDropdown = false;
    }

    if (!clickedInsideActions) {
      this.openedMenuId = null;
    }
  }

  loadContact(id: string): void {
    console.log('Iniciando carga de contacto, ID:', id);
    this.isLoading = true;
    this.errorMessage = '';

    this.api.getContactById({ id }).subscribe({
      next: (response: any) => {
        if (response?.success && response.contacto) {
          this.contacto = response.contacto;
          console.log('Contacto cargado:', this.contacto);
        } else {
          this.errorMessage =
            response?.message || 'No se encontraron datos del contacto';
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error al cargar contacto:', err);
        this.errorMessage = 'Error al cargar los datos del contacto';
        this.isLoading = false;
        this.cdr.detectChanges();
      },
    });
  }

  openNewCall(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.contacto,
        tipo: 'CNT',
        mode: 'call',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewTask(): void {
 this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.contacto,
        mode: 'task',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewEvent(): void {
    this.dialog.open(MdlNewEventComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.contacto,
        mode: 'event',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewfilterActivities(): void {
    this.dialog.open(Mdlfilterectivities, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
    });
  }

  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false;
  }

  openMdlDeleteContact(): void {
    if (!this.contacto_id) return;

    this.dialog.open(MdlDelete, {
      minWidth: '500px',
      minHeight: '260px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'contact',
        id: this.contacto_id,
      },
    });
  }

  openChangeContactModal(): void {
    if (!this.contacto) {
      console.error('No hay datos de contacto disponibles');
      return;
    }

    console.log('Datos del contacto que se enviarán al modal:', this.contacto);

    const dialogRef = this.dialog.open(MdlChangeContact, {
      width: '500px',
      data: {
        contacto: this.contacto,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Resultado del modal:', result);
      if (result?.success) {
        this.loadContact(this.contacto_id);
      }
    });
  }

  openChangeAccountModal(): void {
    console.log('Datos del contacto al abrir modal:', this.contacto);

    const dialogRef = this.dialog.open(MdlChangeContact, {
      width: '500px',
      data: {
        contacto: {
          ...this.contacto,
          nombre: this.contacto.nombre,
          apellido: this.contacto.apellido,
          usuario: this.contacto.usuario,
          cuenta_id: this.contacto.cuenta?.cuenta_id,
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        this.loadContact(this.contacto_id);
        this.alertService.success('Contacto asignado', `Contacto asignado a ${result.account.nombre_empresa}`);
      }
    });
  }


  toggleSection(section: 'info' | 'details' | 'history') {
  if (section === 'info') {
    this.showInfoSection = !this.showInfoSection;
  } else if (section === 'details') {
    this.showDetailsSection = !this.showDetailsSection;
  } else if (section === 'history') {
    this.showHistorySection = !this.showHistorySection;
  }

}

  toggleEdit(section: 'info' | 'details') {
    if (section === 'info') {
      this.editInfo = !this.editInfo;
    } else if (section === 'details') {
      this.editDetails = !this.editDetails;
    }

    if (this.editInfo || this.editDetails) {
      this.editableContact = { ...this.contacto };
    }
  }

  cancelEdit(section: 'info' | 'details') {
    if (section === 'info') this.editInfo = false;
    if (section === 'details') this.editDetails = false;
    this.editableContact = { ...this.contacto };
  }

 saveSection(section: 'info' | 'details') {
  this.api.updateContact(this.editableContact).subscribe({
    next: (resp: any) => {
      this.alertService.success('Actualización exitosa', 'Contacto actualizado correctamente');

      this.contacto = { ...this.editableContact };

      if (section === 'info') this.editInfo = false;
      if (section === 'details') this.editDetails = false;
    },
    error: (err) => {
      this.alertService.error('Error al actualizar', 'Error al actualizar contacto');
      console.error('Error al guardar contacto:', err);
    },
  });
}

  openSendMail() {
    this.dialog.open(MdlSendMail, {
      minWidth: '750px',
      maxHeight: '700px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'add', // o 'edit'
        mailData: { // Datos iniciales opcionales
          from: 'usuario@empresa.com',
          asunto: 'Asunto predefinido'
        },
        destinatarios: ['cliente@empresa.com'],
        tipo: 'individual'
      }
    });
  }

}
